const REFERRAL_CODE_STATE = {
  Disabled: "Disabled",
  Optional: "Optional",
  Required: "Required"
};

export default REFERRAL_CODE_STATE;
